import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import partner1 from "@/assets/partner-logo-1.png";
import partner2 from "@/assets/partner-logo-2.png";
import partner3 from "@/assets/partner-logo-3.png";
import partner4 from "@/assets/partner-logo-4.png";
import partner5 from "@/assets/partner-logo-5.png";
import partner6 from "@/assets/partner-logo-6.png";
import partner7 from "@/assets/partner-logo-7.png";
import partner8 from "@/assets/partner-logo-8.png";
import partner9 from "@/assets/partner-logo-9.png";

const partners = [partner1, partner2, partner3, partner4, partner5, partner6, partner7, partner8, partner9];

/** Bande de logos — identique à la homepage actuelle (marquee + fondus latéraux). */
const CredibilityV2 = () => {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden py-12 md:py-20 md:border-y md:border-border/50">
      <div className="mx-auto max-w-[1280px] px-5 mb-8 md:px-8 md:mb-12">
        <motion.h3
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center font-heading text-lg font-semibold leading-snug text-muted-foreground md:text-2xl md:font-bold"
        >
          {t("partners.title")}
        </motion.h3>
      </div>

      {/* Marquee Container */}
      <div className="relative">
        <div className="flex animate-marquee whitespace-nowrap">
          {[...partners, ...partners].map((partner, index) => (
            <div key={index} className="mx-6 flex h-12 flex-shrink-0 items-center md:mx-8 md:h-16">
              <img
                src={partner}
                alt={`Logo d'une entreprise cliente d'Agence 80/20 (${(index % partners.length) + 1})`}
                loading="lazy"
                decoding="async"
                className="h-full w-auto object-contain opacity-70 hover:opacity-100 transition-opacity duration-300"
              />
            </div>
          ))}
        </div>

        {/* Gradient overlays */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-background to-transparent pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-background to-transparent pointer-events-none" />
      </div>
    </section>
  );
};

export default CredibilityV2;
